(function($) {
    /**
    * Get window coordinate and position
    */
    
    var bookingSummaryBottomInit = function () {
        
        function getWindowCoordinate() {
            var coordinate = {
                x: window.scrollX || window.pageXOffset,
                y: window.scrollY || window.pageYOffset,
                w: window.innerWidth,
                h: window.innerHeight,
            };
            return {
                ...coordinate,
                right: coordinate.x + coordinate.w,
                bottom: coordinate.y + coordinate.h
            }
        }
        
        /**
        * Get element coordinate and position
        * @param {String} el class OR id of element
        */
        function getCoordinate(el) {
            var element = document.querySelector(el);
            if (element === null) {
                return {
                    x: 9999,
                    y: 9999,
                    w: 9999,
                    h: 9999,
                    right: 0,
                    bottom: 0,
                };
            }
            
            var coordinate = {
                x: element.offsetLeft,
                y: element.offsetTop,
                w: element.clientWidth,
                h: element.clientHeight
            }
            return {
                ...coordinate,
                right: coordinate.x + coordinate.w,
                bottom: coordinate.y + coordinate.h,
            }
        }
        
        /**
        * Scroll FX for Summary Component
        * @version prototype
        */
        var $cs = $('.component-summary');
        var $csb = $('.component-summary-bar');
        
        var componentSummaryReCalcurate = function() {
            if ($('.component-summary').length === 0) return;
                
            var $csb_local = $('.component-summary-bar');
            var trigger = getCoordinate('.component-summary').y + getCoordinate('.component-summary-bar').h;
            if (getWindowCoordinate().bottom >= trigger) {
                $csb_local.addClass('component-summary-bar--hide');
            } else {
                $csb_local.removeClass('component-summary-bar--hide');
            }
        }
        
        var $win = $(window);
        var $elements = $('.list-result-content, .refine-search');
        $win.on('load', componentSummaryReCalcurate);
        $win.on('resize scroll', componentSummaryReCalcurate.throttle(16));
        $elements.on('shown.bs.collapse', componentSummaryReCalcurate);
        $elements.on('hidden.bs.collapse', componentSummaryReCalcurate);
        
        /**
        * Register method to global for recalculate position of component summary
        * @since 2019-06-06
        */
        $.extend(true, window.TL, {
            summary: {
                recalc: componentSummaryReCalcurate
            }
        });     
    };
    
    console.log('BookingSummaryBottomInit called.');
    
    if (window.BookingSummaryBottomInit === undefined) {
        window.BookingSummaryBottomInit = bookingSummaryBottomInit;
    }
    window.BookingSummaryBottomInit();
    
    
    /**
    * Attach event for check position when .block-content collapsed
    */
    if (window.BlockContentAttachEvents === undefined) {
        window.BlockContentAttachEvents = function() {
            $('#result .block-content').on('shown.bs.collapse hidden.bs.collapse', () => TL.summary.recalc());
        };
    }
    
    window.BlockContentAttachEvents();
})(jQuery);